export const convertDashToUnderscore = (string: string): string => {
  return string.replace(/-/g, '_')
}
